import React from "react";
import { useDispatch } from "react-redux";

import { LocalisationProvider } from "@hooks/useLocalisation";

import { setLanguage } from "@soft/redux/localisation/localisation.actions";

interface Props {
  children: React.ReactNode;
}

const LanguageDetector = (props: Props): React.ReactElement => {
  const dispatch = useDispatch();

  return (
    <LocalisationProvider
      onLanguageChange={lang => dispatch(setLanguage(lang))}
      skipSetCountryOnMount
    >
      {props.children}
    </LocalisationProvider>
  );
};

export { LanguageDetector };
